import { createSelector } from '@reduxjs/toolkit';

import { TRootState } from '../index';
import { ITransactionsState } from './transactions.slice';

/**
 A selector function to retrieve the transactions data from the store
 @function
 @param {TRootState} state - The root state of the Redux store
 @returns {ITransactionsState} The transactions state object from the Redux store
 */
const selectTransactionsState = (state: TRootState): ITransactionsState => state.transactions;

/**
 A memoized selector function to retrieve the transactions state from the store
 @function
 @type {import('@reduxjs/toolkit').OutputSelector<RootState, ITransactionsState, (res: ITransactionsState) => ITransactionsState>}
 */
export const getTransactionsState = createSelector(
  [selectTransactionsState],
  (state): ITransactionsState => state
);
